/**
 * Lowercases and hyphenates a title into a slug fragment, e.g. "BNL" -> "bnl"
 * and "Kultur & Nöje" -> "kultur-noje". Diacritics are stripped rather than
 * dropped outright, so Swedish titles like "Löpsedel" become "lopsedel" instead
 * of losing the letter entirely.
 *
 * Shared by the two strings a memo is tagged with a section or a type in: a
 * slugline resolved from a template pattern, and the editorial-info type a
 * Print-PM's slugline ends in.
 */
export function slugify(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLocaleLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}
